// eslint-disable-next-line import/prefer-default-export
export const fieldsDefinitions = {
  Cor: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.color',
    decimal: 2,
  },
  IndiceNeutralizacao: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.neutralization-index',
    decimal: 3,
  },
  TensaoInterfacial25: {
    min: '0',
    max: '1000000',
    temperature: 25,
    name: 'fields.physical-chemical-analysis.interfacial-tension',
    decimal: 3,
  },
  RigidezDieletrica: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.dielectric-strength',
    decimal: 3,
  },
  TeorAgua: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.water-content',
    decimal: 1,
  },
  TeorAgua20: {
    min: '0',
    max: '1000000',
    temperature: 20,
    name: 'fields.physical-chemical-analysis.corrected-water-content',
    decimal: 1,
  },
  FatorDissipacao25: {
    min: '0',
    max: '100',
    temperature: 25,
    name: 'fields.physical-chemical-analysis.dissipation-factor',
    decimal: 3,
  },
  FatorDissipacao90: {
    min: '0',
    max: '100',
    temperature: 90,
    name: 'fields.physical-chemical-analysis.dissipation-factor',
    decimal: 3,
  },
  FatorDissipacao100: {
    min: '0',
    max: '100',
    temperature: 100,
    name: 'fields.physical-chemical-analysis.dissipation-factor',
    decimal: 3,
  },
  DensidadeRelativa: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.density',
    decimal: 3,
  },
  TeorInibidorDbpc: {
    min: '0',
    max: '100',
    name: 'fields.physical-chemical-analysis.inhibitor-content',
    decimal: 2,
  },
  TeorPcb: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.pcb-content',
    decimal: 2,
  },
  Rbot: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.rbot',
    decimal: 1,
  },
  TeorFurfuraldeido: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.furfuraldehyde',
    decimal: 2,
  },
  PontoFulgor: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.flash-point',
    decimal: 1,
  },
  TeorPassivador: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.passivator-content',
    decimal: 2,
  },
  ContagemParticulas: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.particle-count',
    decimal: 1,
  },
  Resistividade20: {
    min: '0',
    max: '1000000',
    temperature: 20,
    name: 'fields.physical-chemical-analysis.resistivity',
    decimal: 2,
  },
  Resistividade90: {
    min: '0',
    max: '1000000',
    temperature: 90,
    name: 'fields.physical-chemical-analysis.resistivity',
    decimal: 2,
  },
  TeorDbds: {
    min: '0',
    max: '1000000',
    name: 'fields.physical-chemical-analysis.dibenzyldisulfide-content',
    decimal: 3,
  },
  SaturacaoOleo: {
    min: '0',
    max: '100',
    name: 'fields.physical-chemical-analysis.oil-saturation',
    decimal: 1,
  },
  SaturacaoPapel: {
    min: '0',
    max: '100',
    name: 'fields.physical-chemical-analysis.paper-saturation',
    decimal: 1,
  },
  TemperaturaAmostra: {
    min: '-1000',
    max: '1000',
    name: 'fields.physical-chemical-analysis.sample-temperature',
    decimal: 1,
  },
  TemperaturaAmbiente: {
    min: '-1000',
    max: '1000',
    name: 'fields.physical-chemical-analysis.ambient-temperature',
    decimal: 1,
  },
  AspectoVisual: {
    name: 'fields.physical-chemical-analysis.visual-aspect',
    max: '150',
  },
  LocalAmostragem: {
    name: 'fields.physical-chemical-analysis.oil-sampling-location',
    max: '500',
  },
  Observacao: {
    name: 'fields.general.observations',
    max: '500',
  },
  UmidadeRelativaAr: {
    min: '0',
    max: '100',
    name: 'fields.physical-chemical-analysis.relative-humidity',
    decimal: 1,
  },
  DataHoraAmostragem: {
    min: '1950-01-01T00:00:000Z',
    max: null,
    isDate: true,
    name: 'engineering.sample-date-time',
  },
  DataHoraAnalise: {
    min: '1950-01-01T00:00:000Z',
    max: null,
    isDate: true,
    name: 'fields.physical-chemical-analysis.analysis-date',
  },
  TotalGasesDissolvidosOleo: {
    name: 'fields.physical-chemical-analysis.dissolved-gases',
    min: '0',
    max: '1000000',
    decimal: 1,
  },
  TotalGasesDissolvidos: {
    name: 'fields.physical-chemical-analysis.dissolved-gases',
    min: '0',
    max: '1000000',
    decimal: 1,
  },
  DiferencaPontoFulgorEmGraus: {
    name: 'fields.physical-chemical-analysis.flash-point-degrees-difference',
    decimal: 1,
  },
  DiferencaPontoFulgorEmPorcentagem: {
    name: 'fields.physical-chemical-analysis.flash-point-percent-difference',
  },
  TaxaDecaimentoPassivador: {
    name: 'fields.physical-chemical-analysis.passivator-decay-rate',
  },
  PorcentagemTeorOriginalInibidorDbpc: {
    name: 'fields.physical-chemical-analysis.original-dbpc-inhibitor-content',
  },
  TipoAmostra: {
    name: 'fields.physical-chemical-analysis.sample-type',
  },
};
